import {Routers} from '@/router/routers'
///otherrouter为所有的路由，根据roles筛选用户可用的路由
//路由名称可选  服务端或者本地默认
function filterRouter(roles, otherRouter) {
    let router = otherRouter.filter(item => {
        if (ifHasPermission(roles, item)) {
            if (item.children && item.children.length) {
                item.children = filterRouter(roles, item.children);
            }
            return true;
        }
        return false;
    })
    return router;
}
///roles为用户有的权限
function ifHasPermission(roles, router) {
    return roles.some(item => (item.FUNCTIONID === router.path || '/' + item.FUNCTIONID === router.path))
}
const menu = {
    state: {
        availableMenu: [],
        CacheView: ["Home"]
    },
    mutations: {
        SET_AVALIABLE_MENU(state, menu) {
            state.availableMenu = menu
        },
        ADD_CACHEVIEW: (state, view) => {
            if (!state.CacheView.some(it => it === view.name)) {
                state.CacheView.push(view.name);
            }
        },
        DEL_CACHEVIEW: (state, view) => {
            let index = state.CacheView.findIndex(item => item === view.name);
            if (index !== -1) {
                state.CacheView.splice(index, 1);
            }
        }
    },
    actions: {
        getAvailableMenu({commit}, menus) {
            return new Promise((resolve, reject) => {
                let returnRouter = Routers
                if (!returnRouter.length) {
                    return reject("当前登录用户没有可用菜单")
                }
                let vue404 = permissionRouters.find(item => item.name == 'page404');
                if (vue404) {
                    returnRouter.push(vue404);
                }
                commit("SET_AVALIABLE_MENU", returnRouter)
                return resolve(returnRouter);
            })
        },
        add_Menus({ commit }, view) {
            commit('ADD_CACHEVIEW', view);
        },
        del_Menus({commit},view){
            commit('DEL_CACHEVIEW', view);
        }
    }
}
export default menu